export default __webpack_public_path__ + "static/media/shilotte.c3a6f2db.svg";